import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { SharedServices } from '../../../../services/shared.services'
import { AuthService } from '../../../../services/auth.services'
import { Router } from '@angular/router'
import { RestServices } from '../../../../services/rest.services'
import { notification } from 'onsenui'
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged'
import { PaymentHelper } from '../../../../../helper/payment.helper'
import { PATTERNS, SETTING_KEYS } from '@app/shared/constants/system.const'
import { CommonSettingModel } from '@app/shared/models/common-setting.model'

@Component({
    selector: 'app-common',
    templateUrl: './common.component.html',
    styleUrls: ['../../../../stagingcss/main-body.component.css', './common.component.css', '../../../../stagingcss/lui-select.component.css'],
})
export class CommonComponent implements OnInit {
    // @ViewChild('zipCodeInput') zipCodeInput: ElementRef;
    readonly PATTERNS = PATTERNS
    readonly SETTING_KEYS = SETTING_KEYS
    nameTimeZone
    nameCountry
    listCommon
    // body
    city: string
    address: string
    registrationMail: string
    phone: string
    clinicName: string
    contactPerson: string
    countryCode: string
    en = {}
    showEN = true
    distryFormCommon = true
    termsAprove = 'Please approve the document'
    policyAprove = 'Please approve the document'
    validate: any = {}
    rtRemoved = false
    defaultTimeZone
    defaulfCountry
    zipCode: string
    businessName: string
    taxRate: any
    invalidData: CommonSettingModel = {} as CommonSettingModel
    checkLeng: any;

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
    }

    ngOnInit() {
        this._sharedService.changeEmittedSource$.pipe(distinctUntilChanged()).subscribe(success => {
            if (success[1] === 'activeTimeZone') {
                this.nameTimeZone = success[0]
                this.defaultTimeZone = success[0]
            } else if (success[1] === 'activeCountry') {
                this.nameCountry = success[0]
                this.countryCode = success[2]
                this.defaulfCountry = success[2]
            } else if (success === 'saveComon') {
                if (!this.rtRemoved) {
                    this.saveCommon()
                }
            } else if (success === 'alertDiscard') {
                this.alertDiscardSave()
            } else if (success === 'aproveTerms') {
                this.saveTerms()
            } else if (success === 'aproveTPolicy') {
                this.savePolicy()
            }
        })
        this.getCommon()
    }

    ngOnDestroy() {
        this.rtRemoved = false
    }

    getUniqueTimezone(value) {
        const moment = require('moment-timezone')
        if (value) {
            const tz = moment.tz.zone(value)
            const list = tz.abbrs
            const uniqueArray = list.filter(function(item, pos) {
                return list.indexOf(item) === pos
            })
            const addTimeZone = uniqueArray ? '(' + uniqueArray.join(', ') + ')' : ''
            return addTimeZone
        }
        return ''
    }

    getTimeZone() {
        this._sharedService.emitChange(['activeTimeZoneCommon', this.defaultTimeZone])
    }

    getCountry() {
        this._sharedService.emitChange(['activeCountryCommon', this.defaulfCountry])
    }

    modalContactOTC() {
        this._sharedService.emitChange('activeContacOrTho')
    }

    changeLanguage() {
        this.checkLeng = localStorage.getItem('lang');
        return this.en = this.authData.showLang(this.showEN)
    }

    checkKeyZipCode() {
        const zipCodeTemp = this.zipCode.replace(/\s/g, "").replace(/-/g, '')
        if(zipCodeTemp.length > 0) {
            const first = zipCodeTemp.replace(/\s/g, "").slice(0, 3).replace(/-/g, '')
            const last = zipCodeTemp.replace(/\s/g, "").slice(3, zipCodeTemp.replace(/\s/g, "").length).replace(/-/g, '')
            if(zipCodeTemp.replace(/\s/g, "").length < 3) {
                this.zipCode = `${first}`
            }
            else if(zipCodeTemp.replace(/\s/g, "").length === 3) {
                this.zipCode = `${first}-`
            }
            else {
                this.zipCode = `${first}-${last}`
            }
        }
    }

    preventPaste(event: ClipboardEvent) {
        event.preventDefault();
    }

    preventSpace(event: KeyboardEvent) {
        if (event.key === ' ' || event.code === 'Space' || event.key === '-') event.preventDefault();
    }

    distryFrom(validateFunction: Function = null) {
        if (validateFunction) {
            validateFunction()
        }
        this.distryFormCommon = true
        this._sharedService.emitChange('activeAlertSaveCommon')
    }

    // list staff
    getCommon() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        alignerMail: true, common: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const commonSetting = success['response']['setting']['map']['common']

                this.listCommon = commonSetting
                //
                this.city = this.listCommon.city
                this.address = this.listCommon.address
                this.phone = this.listCommon.phone
                this.clinicName = this.listCommon.clinicName
                this.contactPerson = this.listCommon.contactPerson
                this.registrationMail = success['user']['registrationMail']
                if (this.listCommon['approve_termsOfService']) {
                    this.termsAprove = 'Approved'
                }
                if (this.listCommon['approve_privacyPolicy']) {
                    this.policyAprove = 'Approved'
                }
                const countries = require('country-list')()
                if (this.listCommon['countryCode']) {
                    this.nameCountry = countries.getName(this.listCommon['countryCode'])
                }

                this.validateInfo(success['user'], commonSetting)
                this.defaultTimeZone = this.listCommon.timezone
                this.defaulfCountry = this.listCommon.countryCode
                this.zipCode = this.listCommon.zipCode
                this.businessName = this.listCommon.businessName
                this.taxRate = this.listCommon.taxRate
            })
        })
    }

    // save update common
    saveCommon() {        
        const valueCommon = {
            address: this.address,
            city: this.city,
            clinicName: this.clinicName,
            contactPerson: this.contactPerson,
            countryCode: this.countryCode,
            phone: this.phone,
            timezone: this.nameTimeZone,
            updateTime: Date.now(),
            zipCode: this.zipCode,
            businessName: this.businessName,
            taxRate: this.taxRate,
        }
        // Check properties's required validation of form
        if (!this.distryFormCommon) return

        // Check data of form valid or not
        let invalid = false
        Object.keys(this.invalidData).forEach((key: string) => {
            if (this.invalidData[key]) invalid = true
        })
        if (invalid) return

        const resourceData = {
            actions: [{
                type: 'update', collection: 'setting', id: 'common', value: valueCommon,
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.distryFormCommon = false
                const commonSetting = success['response']['setting']['map']['common']
                this.listCommon = commonSetting
                this._sharedService.emitChange('cancelCommon')

                this.validateInfo(success['user'], commonSetting)
            })
        })
    }

    // save update terms
    saveTerms() {
        const valueCommon = {
            name: 'terms_of_service20170817.txt',
            updateTime: Date.now(),
        }
        const resourceData = {
            actions: [{
                type: 'update', collection: 'setting', id: 'common', value: { approve_termsOfService: valueCommon },
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        if (this.termsAprove != 'Approved') {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                    this.listCommon = success['response']['setting']['map']['common']
                    this.termsAprove = 'Approved'
                    // this._sharedService.emitChange('cancelCommon');
                })
            })
        }
    }

    // save policy
    savePolicy() {
        const valueCommon = {
            name: 'privacy_policy20170817.txt',
            updateTime: Date.now(),
        }
        const resourceData = {
            actions: [{
                type: 'update', collection: 'setting', id: 'common', value: { approve_privacyPolicy: valueCommon },
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        if (this.policyAprove != 'Approved') {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                    this.listCommon = success['response']['setting']['map']['common']
                    this.policyAprove = 'Approved'
                    // this._sharedService.emitChange('cancelCommon');
                })
            })
        }
    }

    // show alert
    showModalSaveMail() {
        let result = this.PATTERNS.PATTERN_002.test(this.zipCode)
        if (this.zipCode.length !== 8 || !result) {
            this.invalidData.zipCode = '半角数字とハイフンで、8文字までで入力してください。'
        } else {
            this.invalidData.zipCode = null
        }
        this.validateTaxRate()
        if (!this.distryFormCommon) return

         // Check data of form valid or not
         let invalid = false
         Object.keys(this.invalidData).forEach((key: string) => {
             if (this.invalidData[key]) invalid = true
         })
         if (invalid) return
 
        const valueCommon = {
            address: this.address,
            city: this.city,
            clinicName: this.clinicName,
            contactPerson: this.contactPerson,
            countryCode: this.countryCode,
            phone: this.phone,
            timezone: this.nameTimeZone,
            zipCode: this.zipCode,
            businessName: this.businessName,
            taxRate: this.taxRate,
        }
        // remove value null in Value Action
        for (const key in valueCommon) {
            if (valueCommon[key] === '' || valueCommon[key] === undefined) {
                delete valueCommon[key]
            }
        }

        if (JSON.stringify(valueCommon).length > 2) {
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.getCommon()
                        this._sharedService.emitChange('cancelCommon')
                    }
                    if (i === 2) {  // here this is not cancelled.  1 is correct.
                        this._sharedService.emitChange('cancelCommon')
                        this.saveCommon()

                    }
                },
            })
        }
    }

    alertDiscardSave() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        alignerMail: true, common: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.listCommon = success['response']['setting']['map']['common']
                const countries = require('country-list')()
                if (this.listCommon['countryCode']) {
                    this.nameCountry = countries.getName(this.listCommon['countryCode'])
                }
            })
        })
        this._sharedService.emitChange('closealertSaveMail')
    }

    modalDisplay() {
        this._sharedService.emitChange('activeChooseTheme')
    }

    toDocumentPage() {
        this.router.navigateByUrl('/app/main/setting/document')
    }

    getTerms() {
        this._sharedService.emitChange('activeShowTerms')
    }

    getPolicy() {
        this._sharedService.emitChange('activeShowPolicy')
    }

    validateInfo(user, commonSetting) {
        if (PaymentHelper.checkNeedPaymentInfo(user, commonSetting)) {
            //check valididate

            this.validate.checkTimezone = this.checkNotInfo(commonSetting.timezone)
            this.validate.checkCity = this.checkNotInfo(commonSetting.city)
            this.validate.checkAdress = this.checkNotInfo(commonSetting.address)
            this.validate.checkPhone = this.checkNotInfo(commonSetting.phone)
            this.validate.checkContactPerson = this.checkNotInfo(commonSetting.contactPerson)
            this.validate.checkClinicName = this.checkNotInfo(commonSetting.clinicName)
            this.validate.checkZipCode = this.checkNotInfo(commonSetting.zipCode)
            this.validate.checkBusinessName = this.checkNotInfo(commonSetting.businessName)
            this.validate.checkTaxRate = this.checkNotInfo(commonSetting.taxRate)
        } else {
            this.validate = {}
        }

    }

    checkNotInfo(info) {
        return !!!info
    }

    /**
     * Validate "zip code"
     * - maxlength is 7
     * - access half width character and '-' character
     **/
    validateZipcode(): void {
        let result = this.PATTERNS.PATTERN_002.test(this.zipCode)
        if (this.zipCode.length !== 8 || !result) {
            this.invalidData.zipCode = '半角数字とハイフンで、8文字までで入力してください。'
        } else {
            this.invalidData.zipCode = null
        }
    }

    /**
     * Validate "bussiness name"
     * - maxlength is 256
     **/
    validateBussinessName(): void {
        if (this.businessName.length > 256) {
            this.invalidData.businessName = '256文字までで入力してください'
        } else {
            this.invalidData.businessName = null
        }
    }

    /**
     * Validate "tax rate"
     * - maxlength is 2
     * - access half width character only
     **/
    validateTaxRate(): void {
        if(!this.taxRate) {
            this.invalidData.taxRate = null
            return;
        }
        let result = this.PATTERNS.PATTERN_001.test(this.taxRate.toString())
        if (this.taxRate.toString().length > 3 || !result) {
            this.invalidData.taxRate = '半角数字で3桁までで入力してください。'
        } else {
            this.invalidData.taxRate = null
        }
    }

    checkKeyE(ev: any){
        if(ev.key == 'e' || ev.key == '+' || ev.key == '-') {
            ev.preventDefault();
            return;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/common/common.component.ts